module.exports = __webpack_public_path__ + "img/login-bg.f3a31f28.png";